export async function GetTasksByUnitTreeApi(perfCycleId, positionId) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/tasks/by-unit-tree?perfCycleId=${perfCycleId}&positionId=${positionId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error: ", error);
        res = { success: false, message: "Error fetching tasks by unit tree" };
      });
  } catch (error) {
    console.error(error);
    res = { success: false, message: "Error fetching tasks by unit tree" };
  }

  return res;
}
